import React, { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';
import TabsLayout from '@components/layout/tabs/TabsLayout';
import { businessUserTabs } from './content';
import { getBusinessUserDetailsInfo } from './queries';
import { entityToBusinessUserDetails } from './utils';
import BusinessPartnersAndPlansTab from './tabs/business-partners-and-plans/BusinessPartnersAndPlansTab';
import LeftPanel from './widgets/LeftPanel';
import Stepper from './widgets/stepper/Stepper';
import BusinessUserDetails from './tabs/summary/BusinessUserDetails';
import ProductionAuthorities from './tabs/summary/ProductionAuthorities';
import { useTabsLayoutStyles } from '@styles/sharedStyles';

const SalesforceBusinessUserDetailsPage: React.FC = () => {
  const { classes } = useTabsLayoutStyles();
  const { id: entityId } = useParams<{ id: string }>();

  const {
    refetch,
    data: businessUserData,
    loading,
  } = useQuery(getBusinessUserDetailsInfo, {
    variables: { id: entityId },
    errorPolicy: 'all',
    skip: !entityId,
  });

  const { businessUserDetailsInfo, businessUserStatus } = useMemo(() => {
    if (!businessUserData)
      return { businessUserDetailsInfo: undefined, businessUserStatus: '' };
    const userData = entityToBusinessUserDetails(businessUserData);
    return {
      businessUserDetailsInfo: userData,
      businessUserStatus:
        businessUserData?.SalesforceManagement?.entities?.businessUser?.views?.SalesforceManagement_all?.properties?.Status?.toLowerCase() ||
        '',
    };
  }, [businessUserData]);

  const tabs = () => {
    if (!businessUserDetailsInfo) return businessUserTabs;

    businessUserTabs.tabs[0].widgets[0].children = (
      <section className={classes.tabContents}>
        <BusinessUserDetails
          businessUserStatus={businessUserStatus}
          data={businessUserDetailsInfo}
          onSuccess={refetch}
        />
        <ProductionAuthorities
          businessUserStatus={businessUserStatus}
          data={businessUserDetailsInfo}
          onSuccess={refetch}
        />
      </section>
    );

    businessUserTabs.tabs[1].widgets[0].children = (
      <BusinessPartnersAndPlansTab businessUserStatus={businessUserStatus} />
    );

    return businessUserTabs;
  };

  return (
    <>
      <TabsLayout
        name="policyPageDetails"
        layout={tabs()}
        loading={loading}
        leftChildren={
          <LeftPanel
            data={businessUserDetailsInfo}
            title={businessUserDetailsInfo?.name}
          />
        }
        mainChildren={<Stepper businessUserStatus={businessUserStatus} />}
      />
    </>
  );
};

export default SalesforceBusinessUserDetailsPage;
